module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-flow-4-76dc8d58fa4defa3e84e51e237bbbe78.png";